import script from "./SkilllicenseView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkilllicenseView.vue?vue&type=script&lang=ts&setup=true"

import "./SkilllicenseView.vue?vue&type=style&index=0&id=12c9b2fb&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c9b2fb"]])

export default __exports__